<template>
  <div class="editorial_course_wrap" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
    <div class="editorial_course_title">
      <p class="goback" @click="goback">
        <img src="../../../../static/images/course/icon-3.png" alt="">
        <span>返回</span>
      </p>
      <h2>{{courseName}}</h2>
      <div class="edit_and_preview">
        <el-button v-if="!isEditCourse" @click="isEditCourse = true">编辑基本信息</el-button>
        <el-button v-if="isEditCourse" @click="isEditCourse = false">取消</el-button>
        <el-button v-if="isEditCourse" @click="saveCourseInfo">保存</el-button>
      </div>
    </div>
    <div class="course_info" v-if="!isEditCourse">
      <div class="cc_title">
        <div class="cc_search">
          <el-form :model="ruleForm" status-icon ref="ruleForm" class="demo-ruleForm">
            <el-form-item prop="name">
              <el-input type="text" v-model="ruleForm.name" autocomplete="off" placeholder="请输入任务名称"></el-input>
            </el-form-item>
            <el-form-item prop="taskType" class="taskType">
              <el-select v-model="ruleForm.taskType" placeholder="请选择任务类型" clearable>
                <el-option
                  v-for="item in taskTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="company" class="company">
              <el-select v-model="ruleForm.company" placeholder="请选择所属公司" clearable>
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="status" class="status">
              <el-select v-model="ruleForm.status" placeholder="请选择状态" clearable>
                <el-option value="0" label="未推送"></el-option>
                <el-option value="1" label="已推送"></el-option>
              </el-select>
            </el-form-item>
            <div class="search_btn">
              <el-button type="primary" @click="getTaskList">查询</el-button>
            </div>
          </el-form>
        </div>
        <div class="operation_btn">
          <el-button @click="batchPublish">推送</el-button>
          <el-button @click="batchImport">导入</el-button>
          <el-button @click="addRealTask">新建</el-button>
        </div>
      </div>
      <div class="cc_content" :style="'height:'+(windowHeight-280)+'px'">
        <div class="source_table_title">
          <p><el-checkbox :indeterminate="isIndeterminateSource" v-model="isSelectAll" @change="checked=>handleCheckAllChange(checked)"></el-checkbox></p>
          <p>任务名称</p>
          <p>任务类型</p>
          <p>所属公司</p>
          <p>创建时间</p>
          <p>推送时间</p>
          <p>状态</p>
          <p>操作</p>
        </div>
        <ul v-if="realTaskList.length>0">
          <li v-for="(item,key) in realTaskList" :data-key="item.id" :key="key">
            <div class="select_box">
              <el-checkbox-group v-model="selectTask" @change="checked=>handleCheckedTopicChange(checked)">
                <el-checkbox :label="item.id" :key="item.id"></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="title_box">{{item.taskName}}</div>
            <div class="type_box">{{item.taskFlowName}}</div>
            <div class="company_box">{{item.companyName}}</div>
            <div class="createTime_box">{{item.createTime}}</div>
            <div class="pushTime_box">{{item.doTaskTime}}</div>
            <div class="status_box">
              <span v-if="item.status=='0'">未推送</span>
              <span v-else-if="item.status=='1'">已推送</span>
              <span v-else>--</span>
            </div>
            <div class="operation_box">
              <span title="预览" class="preview_task" @click="previewTask(item)"></span>
              <span v-if="item.doTaskTime==null || item.doTaskTime=='--'" title="编辑" class="edit_task" @click="editTask(item)"></span>
              <span v-if="item.doTaskTime==null || item.doTaskTime=='--'" title="推送" class="publish_task" @click="publishTask(item)"></span>
              <span v-else title="撤回" class="offline_task" @click="offlineTask(item)"></span>
              <span v-if="item.doTaskTime==null || item.doTaskTime=='--'" title="删除" class="delete_task" @click="deleteTask(item)"></span>
            </div>
          </li>
        </ul>
        <div v-else class="no_task">
          <img src="../../../../static/images/wujieguo.png" alt="">
          <p>暂无任务</p>
        </div>
      </div>
      <Pagination
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
        v-if="realTaskList.length"
      ></Pagination>
    </div>
    <div class="edit_info" v-else>
      <edit-course
        ref="editInfo"
        :editCourseInfoForm="editCourseInfoForm"
        :imageUrl="imgUrl" :courseId="Number(courseId)"></edit-course>
    </div>
    <el-drawer :visible.sync="addrealTaskShow" :direction="direction" size="70%" :with-header="false" :destroy-on-close="true" :close-on-press-escape="false" :before-close="closeRealtask">
      <addrealtask :subjectId="editCourseInfoForm.subject" @submitCancel="cancelRealTask" @addTaskList="addTaskList" :editTask="editTaskData" @upadtaTaskList="upadtaTaskList" :addrealTaskShow="addrealTaskShow"></addrealtask>
    </el-drawer>
    <el-drawer :visible.sync="importTaskShow" :direction="direction" size="80%" :with-header="false" :close-on-press-escape="false" :before-close="cancelImport">
      <importTask ref="importTask" @importTaskSave="importTaskSave" :importTaskShow="importTaskShow" @cancelImport="cancelImport" :subject="editCourseInfoForm.subject"></importTask>
    </el-drawer>
    <el-drawer :visible.sync="previewTaskShow" :direction="direction" size="80%" :with-header="false" :close-on-press-escape="false">
      <div class="preview_task_wrap">
        <h2 class="preview_task_title">{{previewTaskData.title}}</h2>
        <img @click="previewTaskShow = false" src="../../../../static/images/close.png" class="preview_task_close"/>
        <div class="preview_task_content" :style="'height:'+(windowHeight-60)+'px'">
          <div v-html="previewTaskData.content"></div>
          <p class="attachment_title" v-if="previewTaskData.attachmentList.length>0">附件列表：</p>
          <ul class="attachment_list" v-if="previewTaskData.attachmentList.length>0">
            <li v-for="val in previewTaskData.attachmentList" :key="val.id">
              <i class="el-icon-document"></i>
              <span>{{val.name}}</span>
            </li>
          </ul>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      :modal="true"
      :modal-append-to-body="true"
      title="推送" width="420px"
      :visible.sync="pushDialogShow" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="true"
      :before-close="pushClickCancel" class="push_dialog">
      <el-form style="margin-top: 20px" :model="pushForm" :rules="pushRules" ref="pushForm" class="push_dialog_form">
        <el-form-item label="推送时间" prop="time" :label-width="formLabelWidth">
          <el-date-picker v-model="pushForm.time" type="date" placeholder="选择日期" :picker-options="expireTimeOption" format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pushClickCancel">取消</el-button>
        <el-button @click="pushClickConfirm('pushForm')">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as api from '../../../api/courseApi'
  import axios from 'axios'
  import qs from 'qs'
  import editCourse from './editCourseInfo'
  import addrealtask from './components/addRealTask'
  import importTask from './components/importTask'
  import Pagination from "../../paginator/paginator";
  export default {
    components: {
      editCourse,addrealtask,importTask,Pagination
    },
    inject: ['reload'],
    data() {
      return {
        loading: false,
        windowHeight: window.innerHeight,
        courseId: this.$route.query.id,//课程ID
        courseName: '无课程',//课程名字
        isEditCourse: false,//是否编辑课程
        editCourseInfoForm:{//编辑课程信息
          courseName: '',
          courseIntroduction: '',
          subject: '',
          classHour: '',
          coursePic: '',
          courseDetails: '',
          post: []
        },
        imgUrl:'',//课程封面
        taskTypeList: [],
        companyList: [],
        ruleForm: {
          name: '',
          taskType: '',
          company: '',
          status: ''
        },
        realTaskList: [],//任务列表
        selectTask: [],//选中的任务
        isIndeterminateSource: false,
        isSelectAll: false,//全选
        direction: 'rtl',
        addrealTaskShow: false,//新建任务
        importTaskShow: false,//导入任务
        pushDialogShow: false,//推送任务
        formLabelWidth: '120px',
        pushForm: {
          time: '',
        },
        pushRules: {
          time: [
            { required: true, message: '请选择时间', trigger: 'blur' },
          ],
        },
        expireTimeOption: {
          disabledDate(date) {
            // return time.getTime() < Date.now() - 8.64e7;   //禁用以前的日期，今天不禁用
            // return date.getTime() <= Date.now();    //禁用今天以及以前的日期
          }
        },
        pageTotal: {//分页
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        previewTaskShow: false,//预览任务窗口
        previewTaskData: {
          title: '',
          content: '',
          attachmentList: []
        },
        editTaskData: null
      }
    },
    created() {
      this.getCourseInfo(this.courseId)
      // /api-resource/taskFlow/find/{subjectId}
    },
    methods: {
      goback(){//返回
        if (this.type == 1 ){
          this.$router.replace({ path: "/resource/courseadmin"});
        } else if (this.type == 2 ){
          this.$router.replace({ path: "/trainingCenter/trainingCourses"});
        } else {
          this.$router.go(-1);
        }
      },
      getTaskList(){//获取任务列表
        this.isSelectAll = false;
        this.isIndeterminateSource = false;
        this.selectTask = []
        let obj = {
          "catalogId": 0,
          "companyId": this.ruleForm.company,
          "courseId": this.courseId,
          "pageNo": this.pageTotal.currentPage,
          "pageSize": this.pageTotal.pageSize,
          "param": this.ruleForm.name,
          "status": this.ruleForm.status,
          "taskFlowType": this.ruleForm.taskType
        }
        api.getTaskList(obj).then(rs=>{
          if(rs.code==0){
            this.realTaskList = []
            if(rs.data.list && rs.data.list.length>0){
              rs.data.list.forEach(v=>{
                let obj = {
                  catalogId: v.catalogId,
                  companyId: v.companyId,
                  companyName: v.companyName,
                  courseId: v.courseId,
                  createTime: v.createTime.substring(0,10),
                  doTaskTime: v.doTaskTime?v.doTaskTime.substring(0,10):'--',
                  id: v.id,
                  questionContent: v.questionContent,
                  resourceId: v.resourceId,
                  status: v.status,
                  taskFlowId: v.taskFlowId,
                  taskFlowName: v.taskFlowName,
                  taskName: v.taskName,
                }
                this.realTaskList.push(obj)
              })
            }else{
              this.realTaskList = []
            }
            this.pageTotal.total = rs.data.total
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      getCourseInfo(courseid){//获取课程信息
        let that = this
        api.getCourseInfo(courseid).then((rs)=>{
          if(rs.code==0){
            that.courseName = rs.data.courseName
            let imgsrc = '';
            if(rs.data.courseLogo != ''){
              let str = rs.data.courseLogo;
              imgsrc = str
            }else{
              imgsrc = ''
            }
            that.imgUrl = imgsrc
            let arr = []
            if(rs.data.courseStationList && rs.data.courseStationList.length>0){
              rs.data.courseStationList.forEach(v=>{
                arr.push(v.stationId)
              })
            }else{
              arr = []
            }
            that.editCourseInfoForm = {
              courseName: rs.data.courseName,
              subject: rs.data.subjectId,
              type: rs.data.courseType,
              coursePic: rs.data.courseLogo,
              classHour: rs.data.courseHour,
              courseIntroduction: rs.data.courseContext,
              courseDetails: rs.data.detail,
              post: arr
            }
          }else{
            this.$messageError(rs.msg)
          }
        }).then(()=>{
          this.getTaskFlow()
          this.getCompany()
          this.getTaskList()
        }).catch((error)=>{
          console.log(error)
        })
      },
      getTaskFlow(){//获取任务流
        api.getTaskFlow(this.editCourseInfoForm.subject).then(rs=>{
          if(rs.code==0){
            this.taskTypeList = rs.data
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      getCompany(){//获取公司
        let that = this
        let obj = {
          courseId: this.courseId
        }
        api.getCompany(obj).then(rs=>{
          if(rs.code==0){
            if(rs.data.length>0){
              that.companyList = rs.data
            }else{
              that.companyList = []
            }
          }else{
            that.$messageError(rs.msg)
          }
        }).catch(err=>{
          console.log(err)
        })
      },
      handleCheckAllChange(val) {//全选
        if(val){
          this.selectTask = []
          this.realTaskList.forEach(item=>{
            this.selectTask.push(item.id);
          })
        }else{
          this.isSelectAll = false;
          this.selectTask = [];
        }
        this.isIndeterminateSource = false;
      },
      handleCheckedTopicChange(value) {//单选
        let checkedCount = value.length;
        this.isSelectAll = checkedCount === this.realTaskList.length;
        this.isIndeterminateSource = checkedCount > 0 && checkedCount < this.realTaskList.length;
      },
      batchPublish(){//批量推送
        let that = this
        if(this.selectTask.length==0){
          this.$messageWarning('请选择要推送项')
          return
        }
        let arr = []
        this.realTaskList.forEach(v=>{
          this.selectTask.forEach(val=>{
            if(v.id == val){
              arr.push(v)
            }
          })
        })
        let ispush = false
        arr.forEach(v=>{
          if(v.doTaskTime && v.doTaskTime!='--'){
            ispush = true
            return
          }
        })
        if(ispush){
          this.$messageWarning('已推送的任务不支持再次推送')
          return
        }
        // this.$tipsDialog(
      	// 	"提示",
      	// 	"确认推送选中项？",
			  //   "",
			  //   "el-icon-warning",
			  //   "rgb(255, 178, 60)"
      	// ).then(() => {
          that.pushDialogShow = true
        // }).catch(() => {

        // });
      },
      pushClickCancel(){// 取消推送
        this.pushDialogShow = false
        this.$refs['pushForm'].resetFields();
      },
      pushClickConfirm(formName){// 确认推送
        let that = this
        this.$refs[formName].validate((valid, formdata) => {
          if (valid) {
            let arr = []
            that.selectTask.forEach(v=>{
              that.realTaskList.forEach(val=>{
                if(v==val.id){
                  let obj = {
                    courseResourceId: v,
                    doTaskTime: that.getNowTime(this.pushForm.time),
                    resourceId: val.resourceId
                  }
                  arr.push(obj)
                }
              })
            })
            api.publishTask({
              realTaskList: arr,
              catalogId: 0,
              courseId: that.courseId
            }).then(rs=>{
              if(rs.code==0){
                that.pushDialogShow = false
                that.$refs[formName].resetFields();
                that.$messageSuccess('推送成功')
                that.getTaskList()
              }else{
                that.$messageError(rs.msg)
              }
            })
          }else{
            console.log('error')
            return false
          }
        })
      },
      batchImport(){//导入
        this.importTaskShow = true
      },
      cancelImport(){//取消导入
        this.importTaskShow = false
      },
      importTaskSave(obj){//保存导入
        this.addTaskList(obj)
      },
      addRealTask(){//新增真实任务侧边框
        this.addrealTaskShow = true
        this.editTaskData = null
      },
      cancelRealTask(){//关闭真实任务侧边框
        this.addrealTaskShow = false
      },
      closeRealtask(){//关闭新增真实任务侧边框
        this.addrealTaskShow = false
      },
      previewTask(item){//预览任务
        api.getAttachmentList({
          questionId: item.resourceId,
          typeSuffix: ''
        }).then(rs=>{
          if(rs.code==0){
            this.previewTaskData = {
              title: item.taskName,
              content: item.questionContent,
              attachmentList: rs.data
            }
            this.previewTaskShow = true
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      editTask(item){//编辑任务
        this.editTaskData = item
        this.addrealTaskShow = true
// console.log(this.editTaskData,"this.editTaskData")
      },
      publishTask(item){//推送任务
        this.selectTask = []
        if(item.doTaskTime=='--'){
          this.selectTask.push(item.id)
          this.pushDialogShow = true
        }else{
          this.$messageWarning('已推送的任务不能重复推送')
        }
      },
      offlineTask(item){//撤回任务
        let that = this
        this.$tipsDialog(
      		"提示",
      		"确定撤回该任务么？",
			    "",
			    "el-icon-warning",
			    "rgb(255, 178, 60)"
      	).then(() => {
          api.offlineTask(item.id).then(rs=>{
            if(rs.code==0){
              that.$messageSuccess('任务已撤回')
              that.getTaskList()
            }else{
              that.$messageError(rs.msg)
            }
          }).catch(error=>{
	      		console.log(error);
	      	})
        }).catch(() => {
          console.log('cancel')
        });
      },
      deleteTask(item){//删除任务
        let that = this
        if(item.doTaskTime && item.doTaskTime!='--'){
          this.$messageWarning('该任务已推送，不支持删除')
          return
        }
        this.$tipsDialog(
          "提示",
          "确认删除选中的任务吗？",
          "",
          "el-icon-warning",
          "rgb(255, 178, 60)"
        ).then(() => {
          let obj = {
            "catalogId": 0,
            "courseId": this.courseId,
            "list": [item.id],
          }
          api.batchDeleteSource(obj).then(rs=>{
            if(rs.code==0){
              that.$messageSuccess('删除成功')
              that.getTaskList();
							this.getCompany();
            }else{
              that.$messageError(rs.msg)
            }
          })
        }).catch(() => {

        });
      },
      addTaskList(obj){//把任务添加到列表
        api.addTaskList(obj).then(rs=>{
          if(rs.code == '0'){
            this.$messageSuccess('添加成功')
            this.addrealTaskShow = false
            this.importTaskShow = false
            this.getTaskList()
						this.getCompany()
          }else{
            this.$messageError(rs.msg)
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      upadtaTaskList(){//更新任务列表
        this.getTaskList()
        this.addrealTaskShow = false
        this.importTaskShow = false
				this.getCompany()
      },
      getNowTime(time){// 格式化时间
        var datetime = new Date(time);
        var year = datetime.getFullYear();
        var month = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
        var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
        return year + "-" + month + "-" + date
      },
			handleCurrentChange(val) {
	      this.pageTotal.currentPage = val;
	      this.getTaskList()
	   	},
	   	handleSizeChange(val){
	   		this.pageTotal.pageSize = val;
	   		this.pageTotal.currentPage = 1;
	      this.getTaskList()
	   	},
      saveCourseInfo(){//编辑课程信息保存
        this.$refs.editInfo.clickConfirm()
      },
      courseReload(){
        this.reload()
      },
      emptyData(){
        this.isIndeterminateSource = false;
        this.isSelectAll = false;
        this.selectTask = [];
      },
    },
    watch: {
      'previewTaskShow': function(val){
        if(!val){
          this.previewTaskData = {
            title: '',
            content: '',
            attachmentList: []
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .editorial_course_wrap{
    height: calc(100% - 32px);
    background: #fff;
    padding: 0 16px;
    margin: 16px 16px 0;
    border-radius: 4px;
    .editorial_course_title{
      height: 60px;
      border-bottom: 1px solid #DDE0E2;
      display: flex;
      align-items: center;
      position: relative;
      h2{
        color: #333;
        font-size: 16px;
        margin-left: 24px;
        position: relative;
        font-weight: 600;
        &::after{
          content: '';
          position: absolute;
          left: -10px;
          top: 3px;
          width: 4px;
          height: 12px;
          background: #5397F7;
        }
      }
      .goback{
        cursor: pointer;
        font-size: 14px;
        display: flex;
        align-items: center;
        span{
          font-size: 14px;
          font-weight: 400;
        }
        img{
          height: 18px;
          margin: 0 3px;
        }
      }
      .edit_and_preview{
        position: absolute;
        right: 0;
        top: 15px;
        button{
          padding: 0 10px;
          height:32px;
          border:1px solid rgba(83,151,247,1);
          border-radius:4px;
          color:#fff;
          background: #5397F7;
        }
        button:hover{
          opacity: 0.8;
        }
      }
    }
    .course_info{
      margin-top: 15px;
      .cc_title{
        width: 100%;
        position: relative;
        display: flex;
        height: 50px;
        /deep/ .cc_search{
          flex: 1;
          height: 50px;
          .el-form{
            height: 50px;
            display: flex;
            align-items: center;
            .el-form-item{
              display: flex;
              margin-right: 10px;
              margin-bottom: 0;
              .el-form-item__label{
                line-height: 32px;
              }
              .el-form-item__content{
                line-height: 32px;
                .el-input{
                  .el-input__inner{
                    height: 32px;
                    line-height: 32px;
                  }
                  .el-input__icon{
                    line-height: 32px;
                  }
                }
                .el-select{
                  .el-input{
                    width: 150px;
                  }
                }
              }
            }
          }
          .search_btn{
            button{
              padding: 0;
              height: 32px;
              width: 60px;
              margin-left: 10px;
              border: none;
            }
          }
        }
        .operation_btn{
          width: 250px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          button{
            height:32px;
            border:1px solid rgba(83,151,247,1);
            opacity:1;
            border-radius:4px;
            color:#fff;
            padding: 0 10px;
            background: #5397F7;
            margin-left: 8px;
            &:hover{
              opacity: 0.8;
            }
          }
        }
      }
      .cc_content{
        width:100%;
        margin: 0;
        overflow-y:auto;
        .el-checkbox-group{
          font-size: inherit
        }
        .source_table_title{
          display: flex;
          height: 40px;
          align-items: center;
          justify-content: space-between;
          p{
            font-size:12px;
            color:rgba(93,100,110,1);
            text-align: center;
            &:nth-child(1){ width: 55px; }
            &:nth-child(2){ flex: 1; text-align: left; padding: 0 16px; box-sizing: border-box; }
            &:nth-child(3){ width: 150px; text-align: left; padding: 0 10px; box-sizing: border-box; }
            &:nth-child(4){ width: 220px; text-align: left; padding: 0 10px; box-sizing: border-box; }
            &:nth-child(5){ width: 10%; }
            &:nth-child(6){ width: 10%; }
            &:nth-child(7){ width: 70px; }
            &:nth-child(8){ width: 180px; }
          }
        }
        ul{
          li{
            width:100%;
            min-height:40px;
            background:rgba(246,248,251,1);
            border-radius:4px;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            font-size:12px;
            color:rgba(13,20,30,1);
            /deep/ .select_box{
              .el-checkbox{
                display: inline-block;
              }
              .el-checkbox__label{
                display: none;
              }
            }
            .operation_box{
              display: flex;
              align-items: center;
              justify-content: center;
              span{
                margin-right: 16px;
                cursor: pointer;
                &:last-child{
                  margin-right: 0;
                }
              }
              .preview_task{
                width: 14px;
                height: 14px;
                background: url('../../../../static/images/course/editSourceIcon/preview.png');
                background-size: 100% 100%;
                &:hover{
                  background: url('../../../../static/images/course/editSourceIcon/preview-hv.png');
                  background-size: 100% 100%;
                }
              }
              .edit_task{
                width: 14px;
                height: 14px;
                background: url('../../../../static/images/course/editSourceIcon/edit.png');
                background-size: 100% 100%;
                &:hover{
                  background: url('../../../../static/images/course/editSourceIcon/edit-hv.png');
                  background-size: 100% 100%;
                }
              }
              .publish_task{
                width: 14px;
                height: 14px;
                background: url('../../../../static/images/course/teachClassIcon/fb.png');
                background-size: 100% 100%;
                &:hover{
                  background: url('../../../../static/images/course/teachClassIcon/fb_hv.png');
                  background-size: 100% 100%;
                }
              }
              .offline_task{
                width: 14px;
                height: 14px;
                background: url('../../../../static/images/course/teachClassIcon/ch.png');
                background-size: 100% 100%;
                &:hover{
                  background: url('../../../../static/images/course/teachClassIcon/ch_hv.png');
                  background-size: 100% 100%;
                }
              }
              .delete_task{
                width: 14px;
                height: 14px;
                background: url('../../../../static/images/course/editSourceIcon/delete.png');
                background-size: 100% 100%;
                &:hover{
                  background: url('../../../../static/images/course/editSourceIcon/delete-hv.png');
                  background-size: 100% 100%;
                }
              }
            }
            div{
              text-align: center;
              word-break: break-all;
              &:nth-child(1){ width: 55px; }
              &:nth-child(2){ flex: 1; text-align: left; padding: 0 16px; box-sizing: border-box; }
              &:nth-child(3){ width: 150px; text-align: left; padding: 0 10px; box-sizing: border-box; }
              &:nth-child(4){ width: 220px; text-align: left; padding: 0 10px; box-sizing: border-box; }
              &:nth-child(5){ width: 10%; }
              &:nth-child(6){ width: 10%; }
              &:nth-child(7){ width: 70px; }
              &:nth-child(8){ width: 180px; }
            }
          }
        }
        .no_task{
          text-align: center;
          img{
            margin-top: 10%;
            margin-bottom: 10px;
          }
        }
      }
    }
    //===============编辑课程信息=============
    /deep/ .edit_course_form{
      width: 80%;
      margin: 48px auto 0;
      .el-form-item{
        width: 100%;
        display: flex;
        .el-form-item__label{
          width: 100px;
          line-height: 32px;
        }
      }
      .el-form-item__content{
        width: calc(100% - 100px);
        line-height: 32px;
        .el-input{
          width: 80%;
          .el-input__inner{
            height: 32px;
            line-height: 32px;
          }
          .el-input__icon{
            line-height: 32px;
          }
        }
        .el-textarea{
          width: 80%;
          .el-input__count{
            line-height: 20px;
          }
        }
      }
      .classHour{
        .el-form-item__content{
          .el-input{
            width: 260px;
          }
        }
      }
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &:hover{
          border-color: #409EFF;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width:88px;
          height:88px;
          line-height: 88px;
          text-align: center;
        }
        .avatar {
          max-width:154px;
          min-width:88px;
          height:88px;
          background:rgba(255,255,255,1);
          border:1px solid rgba(226,226,226,1);
          opacity:1;
          border-radius:4px;
          display:block;
        }
      }
      .course_details{
        width: 80%;
      }
    }
    //================推送任务=============
    /deep/ .push_dialog{
      .el-dialog{
        border-radius:8px;
        overflow: hidden;
        .el-dialog__header{
          width:100%;
          height:48px;
          background:rgba(237,244,255,1);
          padding: 20px 15px 0 15px;
          box-sizing:border-box;
          span{
            display: block;
            font-size:14px;
            font-weight:400;
            color:rgba(83,151,247,1);
            border-left: 2px solid #5397F7;
            line-height:10px;
            padding-left: 5px;
          }
          .el-dialog__headerbtn{
            top:18px;
          }
        }
        .el-dialog__body{
          padding: 0;
          .push_dialog_form{
            margin-bottom: 24px;
          }
          .el-input{
            width: 240px;
            .el-input__inner{
              width: 240px;
            }
          }
          .el-textarea__inner{
            width:240px;
            height:80px;
            border:1px solid rgba(226,226,226,1);
            border-radius:4px;
            resize: none;
          }
        }
        .el-dialog__footer{
          padding-top:0;
          button{
            width: 80px;
            height: 32px;
            border: 1px solid rgba(83,151,247,1);
            border-radius: 4px;
            padding: 0;
            color: #5397F7;
          }
          button:hover{
            background: #5397F7;
            color: #fff;
          }
        }
      }
    }
    .preview_task_wrap{
      .preview_task_close{
        position: absolute;
        right: 10px;
        top: 13px;
        width: 35px;
        cursor: pointer;
      }
      .preview_task_title{
        font-size:16px;
        font-weight:bold;
        line-height:60px;
        color:rgba(13,20,30,1);
        letter-spacing:1px;
        padding-left: 23px;
        border-bottom: 1px solid #DDE0E2;
      }
      /deep/ .preview_task_content{
        padding: 16px;
        box-sizing: border-box;
        overflow: auto;
        word-break: break-word;
        img{
          max-width: 100%;
        }
        .attachment_title{
          border-top: 1px solid #ccc;
          line-height: 40px;
          margin-top: 20px;
        }
        .attachment_list{
          li{
            font-size: 14px;
            color: #606266;
            line-height: 30px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/course/editTask.vue